
  //   logo section

  $('.logo-slider-main .owl-carousel').owlCarousel({
    // center: true,
    items:2,
    loop:true,
    autoplay:true,
    autoplayTimeout: 4000,
    margin:10,
    responsive:{
        320:{
            items:1
        },
        576:{
            items:2
        },
        768:{
            items:3
        },
        992:{
            items:4
        },
        1200:{
            items:5
        },
        1365:{
          items:6
      },
        1680:{
          items:7
      }
    }
});

// home logo


 //   logo section

 $('.home-logo-slider .owl-carousel').owlCarousel({
  // center: true,
  // items:2,
  loop:true,
  autoplay:true,
  autoplayTimeout: 4000,
  margin:10,
  responsive:{
      320:{
          items:1
      },
      375:{
        items:2
    },
      576:{
          items:2
      },
      768:{
          items:3
      },
      992:{
          items:4
      },
      1200:{
          items:4
      }
  }
});



// mobile sliders recipies
const nextIcon_1 = '<img src="https://cdn.shopify.com/s/files/1/0633/8248/7267/files/pager-left.png?v=1648186626" alt="">';
const prevIcon_2 = '<img src="https://cdn.shopify.com/s/files/1/0633/8248/7267/files/pager-right.png?v=1648186626" alt="">';

$('.japanes-grid-slider .owl-carousel , .subscribe-grid-slider .owl-carousel').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    dots:false,
    autoplayTimeout: 9000,
    slideSpeed: 5000,
    navText: [nextIcon_1, prevIcon_2],
    autoplay:true,
    responsive:{
        0:{
            items:1
        },
    }
  });



//   faq accordions
// bootstrap accordion start
$(document).ready(function(){
    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function(){
      $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
    });
  
  
  
  
    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function(){
      $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
    }).on('hide.bs.collapse', function(){
      $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
    });
  });
  // bootstrap accordion end



//   product page counter strat
 // ========== counter start
 jQuery(document).ready(function () {

    var quantitiy = 0;
    jQuery('.quantity-right-plus').click(function (e) {

      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      var quantity = parseInt(jQuery('#quantity').val());

      // If is not undefined

      jQuery('#quantity').val(quantity + 1);

      // Increment
    });

    jQuery('.quantity-left-minus').click(function (e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      var quantity = parseInt(jQuery('#quantity').val());

      // If is not undefined

      // Increment
      if (quantity > 0) {
        jQuery('#quantity').val(quantity - 1);
      }
    });

  });


// counter end



// review slider
const nextIcon_p1 = '<img src="https://cdn.shopify.com/s/files/1/0633/8248/7267/files/pager-left.png?v=1648186626" alt="">';
const prevIcon_p2 = '<img src="https://cdn.shopify.com/s/files/1/0633/8248/7267/files/pager-right.png?v=1648186626" alt="">';

jQuery(document).ready(function ($) {
    $('.review-slider .owl-carousel').owlCarousel({
        nav: true,
        // items: 3,
        loop: true,
        navText: [nextIcon_p1, prevIcon_p2],
        center: true,
        margin: 0,
        // autoplay:true,
        lazyLoad: true,
        dots: false,
        responsive: {
            320: {
                items: 1,
            },
            576: {
                items: 1,
            },
            1024: {
                items: 3,
            },
            1200: {
                items: 3,
            }
        }
    });
});


// mobile menu

function openNav() {
    document.getElementById("mySidepanel").style.width = "300px";
}

function closeNav() {
    document.getElementById("mySidepanel").style.width = "0";
}



